import React from 'react';
import UserProfilePage from './UserProfilePage';

const ProfilePage = () => {
  console.log('🔍 ProfilePage wrapper is rendering');
  
  // Return the actual UserProfilePage component
  return <UserProfilePage />;
};

export default ProfilePage; 